// ** MUI Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'

// ** Icons Imports
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import { MenuItem, Select } from '@mui/material';
import { isFunction } from '../../../../twilio.min';

interface TableHeaderProps {
    value: string
    toggle: () => void
    handleFilter: (val: string) => void,
    isFunction: boolean,
    onIsFunctionChange: (value: boolean) => void
}

const TableHeader = (props: TableHeaderProps) => {
    // ** Props
    const { handleFilter, toggle, value, isFunction, onIsFunctionChange } = props
    const theme = useTheme();

    return (
        <Box sx={{ p: 5, pb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ mr: 4, mb: 2 }}>
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
                <TextField
                    size='small'
                    value={value}
                    sx={{ mr: 4, mb: 2 }}
                    placeholder='Search Chats'
                    onChange={e => handleFilter(e.target.value)}
                />
                <FormControl>
                    <Select
                        sx={{ mr: 4, mb: 2 }}
                        size='small'
                        value={isFunction ? 'Functions' : 'Chats'}
                        onChange={(e) => onIsFunctionChange(e.target.value === 'Functions')}
                    >
                        <MenuItem value='Chats'>Chats</MenuItem>
                        <MenuItem value='Functions'>Functions</MenuItem>
                    </Select>
                </FormControl>
                {/*<Button style={{ color: 'white' }} sx={{ mb: 2 }} onClick={toggle} size="small" endIcon={<CloudUploadIcon style={{ color: theme.palette.success.main }} />}>*/}
                {/*    Publish*/}
                {/*</Button>*/}
                <Button style={{ color: 'white' }} sx={{ mb: 2 }} onClick={toggle} size="small" endIcon={<AddIcon style={{ color: theme.palette.info.main }} />}>
                    New Chat
                </Button>
            </Box>
        </Box>
    )
}

export default TableHeader
